import {
  HorizontalLabelItem,
  YesNo,
  NestedLabelItem,
  AlertRiskRating
} from '../../components';

export default {
  defaultComponent: {
    itemName: 'default',
    gsPick: ['itemLabel', 'itemName'],
    component: HorizontalLabelItem
  },
  customComponents: [
    {
      itemName: 'isPep',
      gsPick: ['itemLabel', 'itemName'],
      component: YesNo
    },
    {
      itemName: 'isStaff',
      gsPick: ['itemLabel', 'itemName'],
      component: YesNo
    },
    {
      itemName: 'highRiskPartyInfo',
      gsPick: ['itemLabel', 'itemName'],
      component: NestedLabelItem
    },
    {
      itemName: 'riskRating',
      gsPick: ['itemLabel', 'itemName'],
      component: AlertRiskRating
    }
  ]
};
